



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import { IBarChartData } from '@/interfaces'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { BillingModule } from '@/store/modules/billing.module'
import Icon from '@/components/Icon.vue'

const moment = require('moment')

@Component({
  components: {
    Card,
    Icon,
    BarChart,
    LoaderWrapper
  }
})
export default class RevenueByModulesStatistics extends Vue {
  billingInstanceModule: BillingModule = getModule(BillingModule, this.$store);
  isLoading: boolean = false;
  params = {
    months: 8,
    skip: 0
  };
  data: Array<{ data: IBarChartData[], date: Date }>= [];

  get statistics () {
    return this.$store.state.billing.revenueByModulesStatistics || []
  }

  async mounted () {
    this.fetchStatistics()
  }

  tooltipFormatter (total: number) {
    return total
  }

  slideTo (skip: number) {
    this.params.skip += skip
    this.fetchStatistics()
  }

  isPrevAvailable () {
    return this.data.length === 8
  }

  isNextAvailable () {
    return this.params.skip !== 0
  }

  async fetchStatistics () {
    this.isLoading = true
    await this.billingInstanceModule.fetchRevenueByModulesStatistics(this.params)
    this.initStatistics()
    this.isLoading = false
  }
  initStatistics () {
    const maxTotal = Math.max(...this.statistics.map((item: any) => Math.max(
      (item.gross.monthly - item.cost.monthly) + item.cost.monthly,
      (item.gross.payments - (item.cost.payments || 0)) + item.cost.payments,
      (item.gross.mailing - (item.cost.mailing || 0)) + item.cost.mailing
    )))
    this.data = this.statistics.map((item: any) => {
      const date = item.date
      return {
        total: maxTotal,
        data: [{
          items: [{
            value: item.gross.monthly - item.cost.monthly,
            color: '#F0F0FA',
            label: 'Monthly Profit'
          },
          {
            value: item.cost.monthly || 0,
            color: '#9966FF',
            label: 'Monthly Cost'
          }],
          border: '#EDEDF2'
        }, {
          items: [{
            value: item.gross.payments - (item.cost.payments || 0),
            color: '#F0F0FA',
            label: 'Payments Profit'
          },
          {
            value: item.cost.payments || 0,
            color: '#9966FF',
            label: 'Payments Cost'
          }],
          border: '#66CCFF'
        }, {
          items: [{
            value: item.gross.mailing - (item.cost.mailing || 0),
            color: '#F0F0FA',
            label: 'Mailing Profit'
          },
          {
            value: item.cost.mailing || 0,
            color: '#9966FF',
            label: 'Mailing Cost'
          }],
          border: '#9966FF'
        }],
        date
      }
    })
  }
}
